<template lang="pug">
div
  label.label(v-t="'services.consumables_label'")
  .box.branded-box
    table.table.is-fullwidth.is-striped
      thead
        tr
          
          th(v-t="'sale.consumables_heading'")
          th(v-t="'sale.qty_heading'")
          //th Unit
          th(style="text-align: right;")
            span(v-t="'sale.total_heading'")
          th
      tbody
        tr(v-for="consumable in consumables" :key="consumable.product" :class="{'is-disabled': !consumable.enabled}")
          td 
            b-checkbox(v-model="consumable.enabled" @input="update")
              product-name-view(:value="consumable.product" size="is-32x32")
          td
            .field.has-addons
              b-input(v-model.number="consumable.qty" @input="update"  style="width: 80px" :disabled="!consumable.enabled")
              p.control
                ProductUnitLabel.button.is-static(:product="consumable.product")                
          //td
            ProductUnitLabel(:product="consumable.product")              
          td(style="vertical-align: middle; text-align: right;")
            currency-view.has-text-weight-semibold(:value="getConsumablePrice(consumable)")
          td(style="vertical-align: middle;text-align: right;")
            span.icon.has-text-grey.is-clickable.is-size-5(@click="removeItem(consumable)")
              i.mdi.mdi-trash-can-outline
  label.label(v-t="'services.addons_label'")
  .box.branded-box
    table.table.is-fullwidth.is-striped
      thead
        tr
          th(v-t="'sale.consumables_heading'")
          th(v-t="'sale.qty_heading'")
          //th Unit
          th(style="text-align: right;")
            span(v-t="'sale.total_heading'")
          th
      tbody
        tr(v-for="addon in addons" :key="addon.product" :class="{'is-disabled': !addon.enabled}")
          td
            b-checkbox(v-model="addon.enabled" @input="update")
              product-name-view(:value="addon.product" size="is-32x32")
          td
            .field.has-addons
              b-input(v-model.number="addon.qty" @input="update"  style="width: 80px" :disabled="!addon.enabled")
              p.control
                ProductUnitLabel.button.is-static(:product="addon.product")                
          //td
            ProductUnitLabel(:product="addon.product")              
          td(style="vertical-align: middle; text-align: right;")
            currency-view.has-text-weight-semibold(:value="getConsumablePrice(addon)")
          td(style="vertical-align: middle;text-align: right;")
            span.icon.has-text-grey.is-clickable.is-size-5(@click="removeItem(addon)")
              i.mdi.mdi-trash-can-outline
  .buttons.is-centered
    ProductSelector.ml-2.is-rounded.is-primary.is-outlined(@input="onConsumableSelect" type="consumables") 
      span.icon
        i.mdi.mdi-plus-circle-outline
      span(v-t="'sale.actions.add_consumables'")
      
    

</template>
<script>
import {mapActions, mapState} from 'vuex'
import {cloneDeep} from 'lodash'
import ProductView from '../inventory/ProductView'
import ProductUnitLabel from '../inventory/ProductUnitLabel'
import ProductSelector from '../inventory/ProductSelector'
import PRODUCT_TYPES from '../../../constants/productTypes'
export default {
  name: 'ServiceItemConsumablesEditor',
  components: {
    ProductUnitLabel,
    ProductSelector,
    ProductView
  },
  props: {
    value: {type: Array, required: true}
    // locationId: {type: String, required: true}
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    ...mapState('inventory', ['productsMap']),
    consumables() {
      return this.items.filter(v => {
        const product = this.productsMap[v.product]
        if (!product) {
          return false
        }
        return product.type === PRODUCT_TYPES.CONSUMABLES && !product.isAddon
      })
    },
    addons() {
      return this.items.filter(v => {
        const product = this.productsMap[v.product]
        if (!product) {
          return false
        }
        return product.type === PRODUCT_TYPES.RETAIL || product.isAddon
      })
    }
  },

  async created() {
    this.items = cloneDeep(this.value)
  },
  methods: {
    ...mapActions('inventory', ['fetchProduct']),
    async update() {
      this.$emit('input', this.items)
    },
    getConsumablePrice(item) {
      let product = this.productsMap[item.product]
      return item.qty * product.retailPrice
    },
    removeItem(item) {
      this.items.splice(this.items.indexOf(item), 1)
      this.update()
    },
    onConsumableSelect(product) {
      if (this.items.find(c => c.product === product._id)) {
        this.items.find(c => c.product === product._id).qty = +1
        return
      }

      this.items.push({
        product: product._id,
        qty: 1,
        enabled: true,
        isAddon: product.isAddon,
        type: product.type,
        price: product.retailPrice || 0,
        supplyPrice: product.supplyPrice || 0
      })
      this.update()
    }
  }
}
</script>
<style>
tr.is-disabled span {
  color: #999 !important;
}
</style>
